import { createContext, useContext } from "react";

export interface TourLayoutRefresh {
  refreshTourLayout: () => void;
  setSuspendTour: (suspend: boolean) => void;
}

const noop = () => {};

export const TourLayoutRefreshContext = createContext<TourLayoutRefresh>({
  refreshTourLayout: noop,
  setSuspendTour: noop,
});

export function useTourLayoutRefresh(): TourLayoutRefresh {
  return useContext(TourLayoutRefreshContext);
}

